import React, { useEffect, useState } from "react";

import { setLocalKlimVar, trackMixpanel, useClearCache, useNavigate, useToggleNavs, useTranslation, useUserContext } from "utils";

import { MainPage } from "components";

interface ShareData {
  title: string;
  summary: string;
  link: string;
  image: string;
}

export const SignOut = () => {
  const { t } = useTranslation(["signinup", "meta"]);
  const navigate = useNavigate();
  useToggleNavs(false, false);
  useClearCache();
  const { switchFarm } = useUserContext();

  const [share] = useState<ShareData>({
    title: t("meta:signOut.title"),
    summary: t("meta:signOut.description"),
    link: `${process.env.REACT_APP_FARM_URL}/sign-out`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  });

  useEffect(() => {
    setLocalKlimVar("token", null);
    setLocalKlimVar("country", null);

    // Reset farm id, because if a different user tries to sign in, the old farm id
    // would be used leading to the backend returning 401
    switchFarm(null);
    setTimeout(() => {
      navigate("/sign-in");
    }, 300);

    trackMixpanel("Logout");
  }, [navigate, switchFarm, t]);

  return (
    <MainPage pageName={"sign-in-up"} share={share} loading={true}>
      <div></div>
    </MainPage>
  );
};
